export default __webpack_public_path__ + "static/media/Sleep101TeacherAdvert.1c4ee61f.png";